import { createAsyncThunk } from '@reduxjs/toolkit';
import type { IState } from '../store';
import { persistUserPreferences } from './persistUserPreferences';
import type { IBudgetFilterSetFields } from '@app/types';

export const setBudgetFilters = createAsyncThunk<void, Partial<IBudgetFilterSetFields>, { state: IState }>(
  'uiView/setBudgetFilters',
  (_, { dispatch }) => {
    dispatch(persistUserPreferences());
  }
);
